import React, { useState, useEffect, useContext, useRef } from 'react';
import { TRCTextArea } from '../../lib/atoms';
import clsx from 'clsx';
import { StyledRFPApprovalRequestDiv } from './index.styles';
import { serverData } from '../../organisms/RFPComponent/context';
import axios from 'axios';
import { iprops, inputOption, inputEventOption } from './index.types';
import { CheckBox, InputTextField, RadioButton } from '@marriott/mi-ui-library';
import { DropDownComponent } from '../DropDownComponent';

export const RFPApprovalRequest: React.FC<iprops> = (props: iprops) => {
  const jsonContent = useContext(serverData).jsonContent;
  const pageType = jsonContent?.['instanceType'];
  const eventDetails = jsonContent?.['instance']?.eventDetails?.fieldSet
    ? [...jsonContent['instance']['eventDetails']['fieldSet']]
    : [];
  const labels = jsonContent?.['instance']?.labels;
  const [meetingType, setMeetingType] = useState([] as (string | undefined)[]);
  const [keysSuccess, setKeysSuccess] = useState('');
  const [eventHistory, setEventHistory] = useState('');
  const defaultOption = { key: '', value: '' };
  const [selectedAttendeeCount, setSelectedAttendeeCount] = useState(defaultOption);
  const [selectedPreferredSetupLargestSession, setSelectedPreferredSetupLargestSession] = useState(defaultOption);
  const [numBreakoutRooms, setNumBreakoutRooms] = useState('');
  const [attendeeCountLargestSessionBreakout, setAttendeeCountLargestSessionBreakout] = useState('');
  const [_vips, setVips] = useState('');
  const [cateringRequirements, setCateringRequirements] = useState('');
  const [audioVisualRequirements, setAudioVisualRequirements] = useState('');
  const [specialRequirements, setSpecialRequirements] = useState('');
  const [_enteredValue, setEnteredValue] = useState([defaultOption]);
  const [additionalServices, setAdditionalServices] = useState([] as (string | undefined)[]);
  const [showSpecifyOther, setShowSpecifyOther] = useState(false);
  const [specifyOther, setSpecifyOther] = useState('');
  const [questionsComments, setQuestionsComments] = useState('');
  const uploadRef = useRef<HTMLInputElement>(null);
  const [agenda, setAgenda] = useState('');

  const uploadAttachment = async (file: string | Blob, name: string, value: string) => {
    const formdata = new FormData();
    formdata.append('fileToUpload', file);
    try {
      const upload: { status: string } = await axios.post(`/phoenix-trc/v1/uploadAttachment`, formdata, {
        headers: {
          'content-type': 'multipart/form-data',
        },
      });
      if (upload?.status === 'FAILURE') {
        props.onDataChange({
          key: name,
          value: '',
        });
      } else {
        props.onDataChange({
          key: name,
          value: value,
        });
      }
    } catch (err) {
      props.onDataChange({
        key: name,
        value: '',
      });
      console.log(err);
    }
  };

  const onClear = (flag: boolean) => {
    if (flag) {
      setMeetingType([]);
      setKeysSuccess('');
      setEventHistory('');
      //setAttendeeCount('');
      setSelectedAttendeeCount(defaultOption);
      //setPreferredSetupLargestSession('');
      setSelectedPreferredSetupLargestSession(defaultOption);
      setNumBreakoutRooms('');
      setAttendeeCountLargestSessionBreakout('');
      setVips('');
      setCateringRequirements('');
      setAudioVisualRequirements('');
      setSpecialRequirements('');
      setAdditionalServices([]);
      setSpecifyOther('');
      setQuestionsComments('');

      const meetingTypeArr = Array.from(
        document.getElementsByClassName('meetingType') as HTMLCollectionOf<HTMLElement>
      )[0]?.children;
      for (let i = 0; i < meetingTypeArr?.length; i++) {
        if (meetingTypeArr[i]?.children[0]) {
          (meetingTypeArr[i].children[0] as HTMLInputElement).checked = false;
        }
      }
      const vipsArr = Array.from(document.getElementsByClassName('vips') as HTMLCollectionOf<HTMLElement>)[0]?.children;
      for (let i = 0; i < vipsArr?.length; i++) {
        if (vipsArr[i]?.children[0]) {
          (vipsArr[i].children[0] as HTMLInputElement).checked = false;
        }
      }
      const additionalServicesArr = Array.from(
        document.getElementsByClassName('additionalServices') as HTMLCollectionOf<HTMLElement>
      )[0]?.children;
      for (let i = 0; i < additionalServicesArr?.length; i++) {
        if (additionalServicesArr[i]?.children[0]) {
          (additionalServicesArr[i].children[0] as HTMLInputElement).checked = false;
        }
      }
    }
  };

  const onChangeMeetingType = (event: React.ChangeEvent<HTMLInputElement> | React.KeyboardEvent | undefined) => {
    let temp = [];
    let updatedArr = [];
    const target = event?.target as HTMLInputElement;
    const value = target?.value;
    let checked = target?.checked;
    if (event && 'key' in event && (event?.key === 'Enter' || event?.keyCode === 13)) {
      checked = !checked;
    }

    if (checked) {
      setMeetingType(oldArray => [...oldArray, value]);
      updatedArr = [...meetingType, value];
    } else {
      temp = meetingType.filter(e => e !== value);
      setMeetingType(temp);
      updatedArr = [...temp];
    }
    props.onDataChange({
      key: eventDetails[4]?.name,
      value: updatedArr,
    });
  };

  const onChangeAdditionalServices = (event: React.ChangeEvent<HTMLInputElement> | React.KeyboardEvent | undefined) => {
    let temp = [];
    let updatedArr = [];
    const target = event?.target as HTMLInputElement;

    const value = target?.value;
    let checked = target?.checked;
    if (event && 'key' in event && (event?.key === 'Enter' || event?.keyCode === 13)) {
      checked = !checked;
    }

    if (checked) {
      setAdditionalServices(oldArray => [...oldArray, value]);
      updatedArr = [...additionalServices, value];
      if (value === (labels?.otherLabel ?? 'Other')) {
        setShowSpecifyOther(true);
      }
    } else {
      temp = additionalServices.filter(e => e !== value);
      setAdditionalServices(temp);
      updatedArr = [...temp];
      if (value === (labels?.otherLabel ?? 'Other')) {
        setShowSpecifyOther(false);
        setSpecifyOther('');
        const meetOrWed = pageType === 'meetings' ? 18 : 10;
        props.onDataChange({
          key: eventDetails[meetOrWed]?.name,
          value: '',
        });
      }
    }
    const meetOrWed = pageType === 'meetings' ? 16 : 8;
    props.onDataChange({
      key: eventDetails[meetOrWed]?.name,
      value: updatedArr,
    });
  };

  useEffect(() => {
    onClear(props.onClear);
  }, [props.data, props.onClear]);

  return (
    <StyledRFPApprovalRequestDiv data-component-name="m-trc-RFPApprovalRequest" data-testid="trc-RFPApprovalRequest">
      <p className="t-overline-alt-medium t-rc-text-transform-none p-0 offset-0 offset-xl-0 offset-md-2">
        {eventDetails[2]?.fieldName}
      </p>
      <p className="t-overline-alt-medium t-rc-text-transform-none p-0 offset-0 offset-xl-0 offset-md-2">
        {eventDetails[3]?.fieldName}
      </p>
      <div className="eventDetails offset-xl-2 row m-0 d-flex flex-wrap pb-0 mb-0 pb-xl-0 mb-xl-0 pb-md-5 mb-md-5">
        {pageType === 'meetings' && (
          <>
            <p className="t-overline-alt-medium t-rc-text-transform-none col-12 col-xl-12 col-md-8 m-0  mb-4 mb-md-5 mb-xl-3 p-0">
              {eventDetails[4]?.fieldName} *
            </p>
            <div
              data-testid="meetingType"
              className="meetingType col-12 col-xl-12 col-md-8 d-flex  mb-4 mb-md-5 mb-xl-0 flex-wrap"
              role="group"
            >
              {eventDetails[4]?.inputOptions?.map((item: inputOption) => {
                return (
                  <CheckBox
                    checkboxId={`${eventDetails[4]?.name}_${item['option']}`}
                    checkboxName={`${eventDetails[4]?.name}_${item['option']}`}
                    role="option"
                    ariaLabel={`${eventDetails[4]?.name}_${item['option']}`}
                    className={clsx(
                      'checkbox col-xl-6 mt-2',
                      `rfp-${eventDetails[4]?.name}`,
                      props?.data[1]?.isError ? 'error' : ''
                    )}
                    onChange={(e: React.ChangeEvent<HTMLInputElement> | undefined) => onChangeMeetingType(e)}
                    onKeyDown={(e: React.KeyboardEvent) => onChangeMeetingType(e)}
                    checkboxLabel={item['option']}
                    value={item['option']}
                    disabled={props.submitted}
                    checked={((props?.data[1]?.value as Array<string>) ?? []).includes(item['option'])}
                  />
                );
              })}
            </div>
            <div
              className={clsx(
                'error-text t-font-xs col-12 col-xl-12 col-md-8 mb-4 mb-md-5 mb-xl-0',
                props?.data[1]?.isError ? 'd-block' : 'd-none'
              )}
            >
              {eventDetails[4]?.errorMessage}
            </div>

            <TRCTextArea
              textareaId={eventDetails[5]?.name}
              textareaName={eventDetails[5]?.name}
              textareaLabel={`${eventDetails[5]?.fieldName}`}
              className="col-12 col-xl-12 col-md-8  mb-4 mb-md-5 mt-xl-4"
              innerClassName="keysSuccessInput t-rc-alt-border-color"
              placeholder={eventDetails[5]?.placeholder}
              mandatory={eventDetails[5]?.mandatory}
              isError={props?.data[2]?.isError}
              errorMessage={eventDetails[5]?.errorMessage}
              errorMessageClassName="t-font-s"
              inputValue={keysSuccess}
              disabled={props.submitted}
              onChange={(value: string) => {
                setKeysSuccess(value);
                props.onDataChange({
                  key: eventDetails[5]?.name,
                  value: value,
                });
              }}
            />

            <TRCTextArea
              textareaId={eventDetails[6]?.name}
              textareaName={eventDetails[6]?.name}
              textareaLabel={`${eventDetails[6]?.fieldName}`}
              textareaLabelClassName=""
              className="col-12 col-xl-12 col-md-8  mb-4 mb-md-5 mt-xl-4"
              innerClassName="eventHistoryInput t-rc-alt-border-color"
              placeholder={eventDetails[6]?.placeholder}
              mandatory={eventDetails[6]?.mandatory}
              isError={props?.data[3]?.isError}
              errorMessage={eventDetails[6]?.errorMessage}
              errorMessageClassName="t-font-s"
              inputValue={eventHistory}
              disabled={props.submitted}
              onChange={(value: string) => {
                setEventHistory(value);
                props.onDataChange({
                  key: eventDetails[6]?.name,
                  value: value,
                });
              }}
            />

            <div className="col-12 col-xl-12 col-md-8  mb-4 mb-md-5  mt-xl-4">
              <span id={`rfp-${eventDetails[7]?.name}`}></span>
              <p className="t-overline-alt-medium t-rc-text-transform-none p-0 mb-3">{eventDetails[7]?.fieldName}</p>
              <button
                data-testid="rfp-btn"
                className={`m-button-s rfp-btn ${props.submitted ? 'disabled' : ''}`}
                onClick={() => {
                  uploadRef.current && uploadRef.current.click();
                }}
              >
                {' '}
                {eventDetails[7]?.placeholder}
              </button>
              <input
                type="file"
                ref={uploadRef}
                data-testid={eventDetails[7]?.name}
                id={eventDetails[7]?.name}
                className="rfpFile d-none"
                aria-label="Select File"
                disabled={props.submitted}
                accept=".doc,.docx,.pdf"
                onChange={e => {
                  if (e.target.files && e.target.files.length > 0) {
                    const file: File | undefined = e.target.files[0];
                    if (file) {
                      setAgenda(e.target.files[0].name);
                      uploadAttachment(file, eventDetails[7]?.name, e.target.value);
                    }
                  }
                }}
              />
              <span className="ml-2 file-name">{agenda}</span>
              <div
                className={clsx(
                  'error-text mt-3 t-font-xs col-12 col-xl-12 col-md-8',
                  props?.data[17]?.isError ? 'd-block' : 'd-none'
                )}
              >
                {eventDetails[7]?.errorMessage}
              </div>
            </div>

            <div className="rfpApprovalRequest row col-12 col-xl-12 col-md-8 mt-xl-4">
              <DropDownComponent
                className={clsx(`rfp-${eventDetails[8]?.name}`, 'mb-4 mb-md-5 mb-xl-0', 'rfpApprovalRequest-dropdown')}
                dropdownName={`${eventDetails[8]?.fieldName}`}
                dropdownLabel={`${eventDetails[8]?.fieldName}`}
                mandatory={eventDetails[8]?.mandatory}
                dropdownPlaceholder={`${eventDetails[8]?.placeholder ?? 'Select'}`}
                key={eventDetails[8]?.name}
                disabled={props.submitted}
                dropdownValue={eventDetails[8]?.inputOptions?.map((i: inputOption) => {
                  return {
                    key: i.option,
                    value: i.option,
                  };
                })}
                inputValue={selectedAttendeeCount.value}
                panelClassName="dropdown-panel"
                isError={props?.data[4]?.isError}
                errorMessage={eventDetails[8]?.errorMessage}
                selectedOption={selectedAttendeeCount}
                onClick={(v: { key?: string; value?: string }) => {
                  setSelectedAttendeeCount(JSON.parse(JSON.stringify(v)));
                  props.onDataChange({
                    key: eventDetails[8]?.name,
                    value: v?.value,
                  });
                }}
                isTabletView={props?.isTabletView}
                iconAriaLabel={`select your option in ${eventDetails[8]?.name}`}
              />

              <DropDownComponent
                className={clsx(`rfp-${eventDetails[9]?.name}`, 'mb-4 mb-md-5 mb-xl-0', 'rfpApprovalRequest-dropdown')}
                dropdownName={`${eventDetails[9]?.fieldName}`}
                dropdownLabel={`${eventDetails[9]?.fieldName}`}
                mandatory={eventDetails[9]?.mandatory}
                dropdownPlaceholder={`${eventDetails[9]?.placeholder ?? 'Select'}`}
                key={eventDetails[9]?.name}
                disabled={props.submitted}
                dropdownValue={eventDetails[9]?.inputOptions?.map((i: inputOption) => {
                  return {
                    key: i.option,
                    value: i.option,
                  };
                })}
                inputValue={selectedPreferredSetupLargestSession.value}
                panelClassName="dropdown-panel"
                isError={props?.data[5]?.isError}
                errorMessage={eventDetails[9]?.errorMessage}
                selectedOption={selectedPreferredSetupLargestSession}
                onClick={(v: { key?: string; value?: string }) => {
                  setSelectedPreferredSetupLargestSession(JSON.parse(JSON.stringify(v)));
                  props.onDataChange({
                    key: eventDetails[9]?.name,
                    value: v.value,
                  });
                }}
                isTabletView={props?.isTabletView}
                iconAriaLabel={`select your option in ${eventDetails[9]?.name}`}
              />
              <InputTextField
                className={`m-input-field col-xl-6 mt-xl-4 mb-4 mb-md-5 mb-xl-0 rfp-${eventDetails[10]?.name}`}
                type="number"
                label={`${eventDetails[10]?.fieldName}`}
                showErrorMessage={props?.data[6]?.isError}
                setErrorHtml={props?.data[6]?.isError}
                messageToShow={eventDetails[10]?.errorMessage}
                isClickEnabled={true}
                mandatory={eventDetails[10]?.mandatory}
                assignInputValue={numBreakoutRooms ? true : false}
                inputValue={numBreakoutRooms}
                messageClass={'error-text t-font-xs pt-1'}
                isBlurOn={false}
                placeHolderText={eventDetails[10]?.placeholder}
                disabled={props.submitted}
                getInputValue={(value: string) => {
                  setNumBreakoutRooms(value);
                  props.onDataChange({
                    key: eventDetails[10]?.name,
                    value: value,
                  });
                }}
              />
              <InputTextField
                className={`m-input-field col-xl-6 mt-xl-4 mb-4 mb-md-5 mb-xl-0 rfp-${eventDetails[11]?.name}`}
                type="number"
                label={`${eventDetails[11]?.fieldName}`}
                showErrorMessage={props?.data[7]?.isError}
                setErrorHtml={props?.data[7]?.isError}
                messageToShow={eventDetails[11]?.errorMessage}
                isClickEnabled={true}
                mandatory={eventDetails[11]?.mandatory}
                assignInputValue={attendeeCountLargestSessionBreakout ? true : false}
                inputValue={attendeeCountLargestSessionBreakout}
                messageClass={'error-text t-font-xs pt-1'}
                isBlurOn={false}
                placeHolderText={eventDetails[11]?.placeholder}
                disabled={props.submitted}
                getInputValue={(value: string) => {
                  setAttendeeCountLargestSessionBreakout(value);
                  props.onDataChange({
                    key: eventDetails[11]?.name,
                    value: value,
                  });
                }}
              />
              <p className="t-overline-alt-medium t-rc-text-transform-none col-12 col-xl-12 col-md-12 p-0 m-0 mb-xl-3 mb-4 mb-md-5 mt-xl-4">
                {eventDetails[12]?.fieldName}
              </p>
              <div className="vips d-flex flex-wrap col-12 col-xl-12 col-md-12  mb-4 mb-md-5 mb-xl-0">
                {eventDetails[12]?.inputOptions?.map((item: inputOption) => {
                  return (
                    <RadioButton
                      radiobuttonId={`${eventDetails[12]?.name}_${item['option']}`}
                      radiobuttonName={eventDetails[12]?.name + item['option']}
                      radiobuttonLabel={item['option']}
                      disabled={props.submitted}
                      aria-label={`${eventDetails[12]?.name}_${item['option']}`}
                      ariaLabelForLink={`${eventDetails[12]?.name}_${item['option']}`}
                      className={clsx(
                        'm-radio-button-sm',
                        'pr-4',
                        `rfp-${eventDetails[12]?.name}`,
                        props?.data[8]?.isError ? 'error' : ''
                      )}
                      labelClassName="t-font-m"
                      checked={item['option'] === props?.data[8]?.value}
                      onChange={(event: React.ChangeEvent<HTMLInputElement> | undefined) => {
                        event && setVips(event.target.value);
                        props.onDataChange({
                          key: eventDetails[12]?.name,
                          value: event?.target.value,
                        });
                      }}
                      onKeyDown={(event: React.KeyboardEvent) => {
                        if (event?.key === 'Enter' || event?.keyCode === 13) {
                          const target = event?.target as HTMLInputElement;
                          event && setVips(target.value);
                          props.onDataChange({
                            key: eventDetails[12]?.name,
                            value: target?.value,
                          });
                        }
                      }}
                      value={item['option']}
                      setTabIndex={-1}
                    />
                  );
                })}
              </div>
            </div>
            <div
              className={clsx(
                'error-text t-font-xs col-12 col-xl-12 col-md-8',
                props?.data[8]?.isError ? 'd-block' : 'd-none'
              )}
            >
              {eventDetails[12]?.errorMessage}
            </div>

            <TRCTextArea
              textareaId={eventDetails[13]?.name}
              textareaName={eventDetails[13]?.name}
              textareaLabel={`${eventDetails[13]?.fieldName}`}
              textareaLabelClassName=""
              className="col-12 col-xl-12 col-md-8 mt-xl-4  mb-4 mb-md-5"
              innerClassName="textAreaInput t-rc-alt-border-color"
              placeholder={eventDetails[13]?.placeholder}
              mandatory={eventDetails[13]?.mandatory}
              isError={props?.data[9]?.isError}
              errorMessage={eventDetails[13]?.errorMessage}
              errorMessageClassName="t-font-s"
              inputValue={cateringRequirements}
              disabled={props.submitted}
              onChange={(value: string) => {
                setCateringRequirements(value);
                props.onDataChange({
                  key: eventDetails[13]?.name,
                  value: value,
                });
              }}
            />

            <TRCTextArea
              textareaId={eventDetails[14]?.name}
              textareaName={eventDetails[14]?.name}
              textareaLabel={`${eventDetails[14]?.fieldName}`}
              textareaLabelClassName=""
              className="col-12 col-xl-12 col-md-8 mt-xl-4  mb-4 mb-md-5"
              innerClassName="textAreaInput t-rc-alt-border-color"
              placeholder={eventDetails[14]?.placeholder}
              mandatory={eventDetails[14]?.mandatory}
              isError={props?.data[10]?.isError}
              errorMessage={eventDetails[14]?.errorMessage}
              errorMessageClassName="t-font-s"
              inputValue={audioVisualRequirements}
              disabled={props.submitted}
              onChange={(value: string) => {
                setAudioVisualRequirements(value);
                props.onDataChange({
                  key: eventDetails[14]?.name,
                  value: value,
                });
              }}
            />

            <TRCTextArea
              textareaId={eventDetails[15]?.name}
              textareaName={eventDetails[15]?.name}
              textareaLabel={`${eventDetails[15]?.fieldName}`}
              textareaLabelClassName=""
              className="col-12 col-xl-12 col-md-8 mt-xl-4  mb-4 mb-md-5"
              innerClassName="textAreaInput t-rc-alt-border-color"
              placeholder={eventDetails[15]?.placeholder}
              mandatory={eventDetails[15]?.mandatory}
              isError={props?.data[11]?.isError}
              errorMessage={eventDetails[15]?.errorMessage}
              errorMessageClassName="t-font-s"
              inputValue={specialRequirements}
              disabled={props.submitted}
              onChange={(value: string) => {
                setSpecialRequirements(value);
                props.onDataChange({
                  key: eventDetails[15]?.name,
                  value: value,
                });
              }}
            />

            <p className="t-overline-alt-medium t-rc-text-transform-none col-12 col-xl-12 col-md-8 p-0 mt-xl-4  mb-4 mb-md-5 mb-xl-0">{`${
              eventDetails[16]?.fieldName
            }
                        ${eventDetails[16]?.mandatory ? '*' : ''}`}</p>
            <div
              data-testid="additionalServices"
              className="additionalServices col-12 col-xl-12 col-md-8 d-flex flex-wrap  mb-4 mb-md-5 mb-xl-0"
              role="group"
            >
              {eventDetails[16]?.inputOptions?.map((item: inputOption) => {
                return (
                  <CheckBox
                    checkboxId={`${eventDetails[16]?.name}_${item['option']}`}
                    checkboxName={`${eventDetails[16]?.name}_${item['option']}`}
                    role="option"
                    ariaLabel={`${eventDetails[16]?.name}_${item['option']}`}
                    className={clsx(
                      'checkbox col-xl-6 mt-2',
                      `rfp-${eventDetails[16]?.name}`,
                      props?.data[12]?.isError ? 'error' : ''
                    )}
                    onChange={(e: React.ChangeEvent<HTMLInputElement> | undefined) => onChangeAdditionalServices(e)}
                    onKeyDown={(e: React.KeyboardEvent) => onChangeAdditionalServices(e)}
                    checkboxLabel={item['option']}
                    value={item['option']}
                    disabled={props.submitted}
                    checked={((props?.data[12]?.value as Array<string>) ?? []).includes(item['option'])}
                  />
                );
              })}
            </div>
            <div
              className={clsx(
                'error-text t-font-xs col-12 col-xl-12 col-md-8',
                props?.data[12]?.isError ? 'd-block' : 'd-none'
              )}
            >
              {eventDetails[16]?.errorMessage}
            </div>

            {showSpecifyOther && (
              <InputTextField
                className={`m-input-field col-12 col-xl-6 col-md-8 mt-xl-4  mb-4 mb-md-5 mb-xl-0 rfp-${eventDetails[18]?.name}`}
                label={`${eventDetails[18]?.fieldName}`}
                showErrorMessage={props?.data[13]?.isError}
                setErrorHtml={props?.data[13]?.isError}
                messageToShow={eventDetails[18]?.errorMessage}
                isClickEnabled={true}
                mandatory={eventDetails[18]?.mandatory}
                assignInputValue={specifyOther ? true : false}
                inputValue={specifyOther}
                messageClass={'error-text t-font-xs pt-1'}
                isBlurOn={false}
                placeHolderText={eventDetails[18]?.placeholder}
                disabled={props.submitted}
                getInputValue={(value: string) => {
                  setSpecifyOther(value);
                  props.onDataChange({
                    key: eventDetails[18]?.name,
                    value: value,
                  });
                }}
              />
            )}
            <InputTextField
              className={`m-input-field col-12 col-xl-12 col-md-8 mt-xl-4 pb-5 pb-xl-0 pb-md-0 rfp-${eventDetails[17]?.name}`}
              label={`${eventDetails[17]?.fieldName}`}
              showErrorMessage={props?.data[14]?.isError}
              setErrorHtml={props?.data[14]?.isError}
              messageToShow={eventDetails[17]?.errorMessage}
              isClickEnabled={true}
              mandatory={eventDetails[17]?.mandatory}
              assignInputValue={questionsComments ? true : false}
              inputValue={questionsComments}
              messageClass={'error-text t-font-xs pt-1'}
              isBlurOn={false}
              placeHolderText={eventDetails[17]?.placeholder}
              disabled={props.submitted}
              getInputValue={(value: string) => {
                setQuestionsComments(value);
                props.onDataChange({
                  key: eventDetails[17]?.name,
                  value: value,
                });
              }}
            />
          </>
        )}

        {pageType === 'weddings' && (
          <>
            <TRCTextArea
              textareaId={eventDetails[4]?.name}
              textareaName={eventDetails[4]?.name}
              textareaLabel={`${eventDetails[4]?.fieldName}`}
              className="col-12 col-xl-12 col-md-8 mt-xl-4  mb-4 mb-md-5 mb-xl-0"
              innerClassName="weddingRequirements t-rc-alt-border-color"
              placeholder={eventDetails[4]?.placeholder}
              mandatory={eventDetails[4]?.mandatory}
              isError={props?.data[15]?.isError}
              errorMessage={eventDetails[4]?.errorMessage}
              errorMessageClassName="t-font-s"
              disabled={props.submitted}
              onChange={(value: string) => {
                props.onDataChange({
                  key: eventDetails[4]?.name,
                  value: value,
                });
              }}
            />

            {eventDetails.map((item: inputEventOption, index: number) => {
              if (index > 4 && index < 8) {
                return (
                  <TRCTextArea
                    textareaId={item['name']}
                    textareaName={item['name']}
                    textareaLabel={`${item['fieldName']}`}
                    textareaLabelClassName=""
                    className="col-12 col-xl-12 col-md-8 mt-xl-4  mb-4 mb-md-5 mb-xl-0"
                    innerClassName="textAreaInput t-rc-alt-border-color"
                    placeholder={item['placeholder']}
                    mandatory={item['mandatory']}
                    isError={false}
                    errorMessage={item['errorMessage']}
                    disabled={props.submitted}
                    onChange={(value: string) => {
                      setEnteredValue(oldArray => [...oldArray, { key: item['name'], value: value }]);
                      props.onDataChange({
                        key: item['name'],
                        value: value,
                      });
                    }}
                  />
                );
              }
            })}

            <p className="t-overline-alt-medium t-rc-text-transform-none col-12 col-xl-12 col-md-8 p-0 mt-xl-4  mb-4 mb-md-5 mb-xl-0">{`${
              eventDetails[8]?.fieldName
            }
                        ${eventDetails[8]?.mandatory ? '*' : ''}`}</p>
            <div
              data-testid="additionalServicesWeddings"
              className="additionalServices col-12 col-xl-12 col-md-8 d-flex flex-wrap  mb-4 mb-md-5 mb-xl-0"
              role="group"
            >
              {eventDetails[8]?.inputOptions?.map((item: inputOption) => {
                return (
                  <CheckBox
                    checkboxId={`${eventDetails[8]?.name}_${item['option']}`}
                    checkboxName={`${eventDetails[8]?.name}_${item['option']}`}
                    role="option"
                    ariaLabel={`${eventDetails[8]?.name}_${item['option']}`}
                    className={clsx('checkbox col-xl-6 mt-2', `rfp-${eventDetails[8]?.name}`)}
                    onChange={(e: React.ChangeEvent<HTMLInputElement> | undefined) => onChangeAdditionalServices(e)}
                    onKeyDown={(e: React.KeyboardEvent) => onChangeAdditionalServices(e)}
                    checkboxLabel={item['option']}
                    value={item['option']}
                    disabled={props.submitted}
                    checked={((props?.data[12]?.value as Array<string>) ?? []).includes(item['option'])}
                  />
                );
              })}
            </div>
            <div
              className={clsx(
                'error-text t-font-xs col-12 col-xl-12 col-md-8',
                props?.data[12]?.isError ? 'd-block' : 'd-none'
              )}
            >
              {eventDetails[8]?.errorMessage}
            </div>

            {showSpecifyOther && (
              <InputTextField
                className={`m-input-field col-12 col-xl-6 col-md-8 mt-xl-4  mb-4 mb-md-5 mb-xl-0 rfp-${eventDetails[10]?.name}`}
                label={`${eventDetails[10]?.fieldName}`}
                showErrorMessage={props?.data[13]?.isError}
                setErrorHtml={props?.data[13]?.isError}
                messageToShow={eventDetails[10]?.errorMessage}
                isClickEnabled={true}
                mandatory={eventDetails[10]?.mandatory}
                assignInputValue={specifyOther ? true : false}
                inputValue={specifyOther}
                messageClass={'error-text t-font-xs pt-1'}
                isBlurOn={false}
                placeHolderText={eventDetails[10]?.placeholder}
                disabled={props.submitted}
                getInputValue={(value: string) => {
                  setSpecifyOther(value);
                  props.onDataChange({
                    key: eventDetails[10]?.name,
                    value: value,
                  });
                }}
              />
            )}
            <InputTextField
              className={`m-input-field col-12 col-xl-12 col-md-8 mt-xl-4 pb-5 pb-xl-0 pb-md-0 rfp-${eventDetails[9]?.name}`}
              label={`${eventDetails[9]?.fieldName}`}
              showErrorMessage={props?.data[14]?.isError}
              setErrorHtml={props?.data[14]?.isError}
              messageToShow={eventDetails[9]?.errorMessage}
              isClickEnabled={true}
              mandatory={eventDetails[9]?.mandatory}
              messageClass={'error-text t-font-xs pt-1'}
              isBlurOn={false}
              placeHolderText={eventDetails[9]?.placeholder}
              disabled={props.submitted}
              getInputValue={(value: string) => {
                setQuestionsComments(value);
                props.onDataChange({
                  key: eventDetails[9]?.name,
                  value: value,
                });
              }}
            />
          </>
        )}
      </div>
    </StyledRFPApprovalRequestDiv>
  );
};
